import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter/src/TypesenseInstantsearchAdapter"
import { additionalSearchParameters } from "@jobshop/crossroads/utils/search/additionalSearchParameters"
import { checkLocationFacetFilter, checkLocationFilter } from "@jobshop/crossroads/utils/search/handleLocationFilters"
import { facetableFields } from "@jobshop/crossroads/utils/search/facetableFields"

export async function useTypesenseSearchClient(searchConfig: SearchConfig) {
  const { public: { typesenseUrl } } = useRuntimeConfig()
  const { jobShopId } = useHeaderStore()
  const { data: typesenseApiKey } = useNuxtData(`typesenseApiKey-${jobShopId}`)

  // Required for handling nationwide jobs
  const { nationwideText } = searchConfig.filters

  // create typesense search client
  const typesenseInstantsearchAdapter = ref(
    new TypesenseInstantSearchAdapter({
      server: {
        apiKey: typesenseApiKey.value,
        nodes: [
          {
            url: typesenseUrl,
          },
        ],
        cacheSearchResultsForSeconds: 2 * 60,
      },
      geoLocationField: "coordinate",
      facetableFieldsWithSpecialCharacters: facetableFields,
      additionalSearchParameters,
    }),
  )

  const searchClient = ref({
    ...typesenseInstantsearchAdapter.value.searchClient,
    search: (requests) => {
      const newRequests = requests.map((request) => {
        checkLocationFacetFilter(request, nationwideText)
        checkLocationFilter(request, nationwideText)

        return request
      })

      return typesenseInstantsearchAdapter.value.searchClient.search(newRequests)
    },
  })

  return { typesenseInstantsearchAdapter, searchClient }
}
